var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"start"}},[_c('unser-portfolio'),_c('wer-wir-sind'),_c('dafuer-stehen-wir'),_c('was-wir-fuer-sie-tun-koennen'),_c('statements-unserer-kunden'),_c('unsere-referenzen'),_c('unsere-familie'),_c('unsere-hotline')],1)}
var staticRenderFns = []

export { render, staticRenderFns }